import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bulk-select"
// <form data-controller="bulk-select">
//   <input type="checkbox" data-bulk-select-target="all" data-action="bulk-select#toggleAll">
//   <button data-bulk-select-target="submit" disabled>Invite selected</button>
//   <input type="checkbox" name="ids[]" data-bulk-select-target="checkbox" data-action="bulk-select#toggle">
// </form>
export default class extends Controller {
  static targets = ["all", "checkbox", "submit"]

  connect() {
    this.refresh()
  }

  toggleAll() {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = this.allTarget.checked })
    this.refresh()
  }

  toggle() {
    this.refresh()
  }

  refresh() {
    const checkedCount = this.checkboxTargets.filter((checkbox) => checkbox.checked).length

    if (this.hasAllTarget) {
      this.allTarget.checked = checkedCount > 0 && checkedCount === this.checkboxTargets.length
      this.allTarget.indeterminate = checkedCount > 0 && checkedCount < this.checkboxTargets.length
    }

    if (this.hasSubmitTarget) this.submitTarget.disabled = checkedCount === 0
  }
}
